import React from 'react';
import { Underline } from 'styled-icons/boxicons-regular/Underline';

function UnderlineIcon(props) {
  return (
    <Underline {...props} className={'icon'} />
  );
}

export default UnderlineIcon;
